import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/correctionReadyProducts';
import { get, del, post } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';
import { startLoading, stopLoading } from '../actions/settings/loading';

export function* getReadyProducts({ payload }) {
  try {
    const response = yield call(get, `/grid/production/ready_product/list?plantId=${payload.plantId}`);
    yield put(action.getReadyProductsSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getReadyProductsFail());
  }
}

export function* deleteReadyProducts({ payload }) {
  try {
    yield call(del, `/operation/ready/cancel?operationNumId=${payload.operationNumId}`);
    yield put(action.deleteReadyProductsSuccess());
    const response = yield call(get, `/grid/production/ready_product/list?plantId=${payload.plantId}`);
    yield put(action.getReadyProductsSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.deleteReadyProductsFail());
  }
}

export function* deleteReadyProductsMultiple({ payload }) {
  try {
    yield call(del, `/operation/ready/cancel/multiple?operationNumIds=${payload.operationNumIds}`);
    yield put(action.deleteReadyProductsMultipleSuccess());
    const response = yield call(get, `/grid/production/ready_product/list?plantId=${payload.plantId}`);
    yield put(action.getReadyProductsSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.deleteReadyProductsMultipleFail());
  }
}

/** Отправка на монтаж УЕ */
export function* sendForMounting({ payload }) {
  try {
    yield put(startLoading());
    let response = yield call(post, `/grid/production/ready_product/mounting?pieceNumId=${payload.pieceNumId}&operationType=${payload.operationType}`);
    yield put(action.sendForMountingSuccess(response));
    response = yield call(get, `/grid/production/ready_product/list?plantId=${payload.plantId}`);
    yield put(action.getReadyProductsSuccess(response));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message.length
          ? error.response.data.message
          : 'Неизвестная ошибка - обратитесь в службу поддержки',
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.sendForMountingFail());
  }
}
